import { NewsLetterHeader, Swoosh } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  ContactFormHeading: NewsLetterHeader.Proxani,
  NewsletterHeader: {
    SVG: NewsLetterHeader.Proxani,
    className: 'newsletter-svg',
  },
  button: {
    dealerOverview: {
      details: 'primary',
      navigation: 'secondary',
    },
  },
  footer: {
    newsletter: {
      removeBottomPadding: true,
    },
    svg: {
      Desktop: Swoosh,
      Mobile: Swoosh,
      Tablet: Swoosh,
    },
  },
});

export default config;
